import gql from 'graphql-tag';

export const DEAL_SMS_ACTIVITY_FRAGMENT = gql`
  fragment DealSmsActivityFields on DealSmsActivityViewModel {
    id
    type
    parentId
    updatedDateTime
    createdDateTime
    directionType
    message
    smsDirection
    status
    twilioMessageId
    conversationSequenceNumber
    createdByUserProfileId
    ownerPgCreditApplicationId

    ownerPgCreditApplication {
      firstName
      lastName
      title
      phone
      pc
    }

    createdByUserProfile {
      firstName
      lastName
      title
      phoneNumber
    }
  }
`;
